// extracted by mini-css-extract-plugin
module.exports = {"pending":"button_pending__3Za-X","pulse":"button_pulse__12IvK"};